import React, { FC } from 'react';
import styles from './styles.module.css';
import { ChevronDown, ChevronUp, Trash, Merge } from 'lucide-react';
import { Button } from 'antd';
import cx from 'classnames';

type Props = {
  active: boolean;
  open?: boolean;
  onClick: () => void;
  label?: string;
  className?: string;
  deleteButton?: boolean;
  mergeButton?: boolean;
  disabled?: boolean;
};

const ToolbarButton: FC<Props> = ({
  active,
  open,
  onClick,
  label,
  className,
  deleteButton,
  mergeButton,
  disabled = false
}) => {
  const hasDefaultLabel = !mergeButton && !deleteButton;
  const title = hasDefaultLabel
    ? undefined
    : `${deleteButton ? 'Delete' : 'Merge'} selected tasks`;
  const chevron = open ? (
    <ChevronUp className={styles.chevronIcon} />
  ) : (
    <ChevronDown className={styles.chevronIcon} />
  );
  return (
    <Button
      type="primary"
      onClick={onClick}
      className={cx(styles.toolbarButton, className, {
        [styles.active]: active,
        [styles.open]: open,
        [styles.deleteButton]: deleteButton,
        [styles.disabled]: disabled,
        [styles.mergeButton]: mergeButton
      })}
      shape={deleteButton ? 'circle' : 'default'}
      title={title}
      disabled={disabled}
    >
      {deleteButton ? (
        <Trash className={styles.deleteIcon} />
      ) : (
        <div className={styles.labelContainer}>
          {mergeButton && <Merge className={styles.mergeIcon} />}
          {label}
          {!mergeButton && chevron}
        </div>
      )}
    </Button>
  );
};

export default ToolbarButton;
